module.exports = __webpack_public_path__ + "img/Arrow-Macro.886f04c.svg";